import React, { useEffect, useState } from "react";

import { ItemTag } from '../../../../widgets';

const ListTag = (props) => {
    const { tags } = props;

    // const [parent, handleParent] = useState(0);
    // const [listTags, hanleListTag] = useState([]);
    
    // let is_state = false;

    // useEffect(() => {
    //     console.log('parent', parent);
    //     let data = tags.filter((item) => item.parent_id === parent);
    //     if(data.length == 0 && parent != 0){
    //         handleParent(0);
    //     } else {
    //         hanleListTag(data)   
    //     }
    // }, [parent])

    if(!props.contactInfoSelected) return null;

    return <div className="list-tags-container">
        <div className="list-tags-scroll">
            {tags.map((item) => {
                return <ItemTag
                    key={item.tag_id}
                    active={props.contactInfoSelected.tags && props.contactInfoSelected.tags.find((tag) => tag.tag_id == item.tag_id) ? true : false}
                    tag={item}
                    contactInfoSelected={props.contactInfoSelected}
                    handleUpdateTag={props.handleUpdateTag}
                    // handleParent={(value) => handleParent(value)}
                />
            })}
        </div>
    </div>
}

export default ListTag;